import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalSort } from '../../util/local-sort';

/**
 * The sort arrow of a column header: an up or down icon for the sorted column,
 * the neutral icon for the others.
 */
@Component({
  selector: 'app-sort-icon',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<i
    class="app-sort-icon app-icon fa-solid fa-fw"
    aria-hidden="true"
    [class.fa-sort]="order === 0"
    [class.fa-arrow-up-short-wide]="order === 1"
    [class.fa-arrow-down-wide-short]="order === -1"
  ></i>`,
})
export class SortIconComponent {
  @Input() field = '';
  @Input() sort: LocalSort | null | undefined = null;

  get order(): 0 | 1 | -1 {
    return this.sort?.field === this.field ? this.sort.order : 0;
  }
}
